function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "22.352",
  height: "22.352"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("path", {
  id: "Rectangle_3323",
  "data-name": "Rectangle 3323",
  fill: "#ec1b3b",
  d: "M0 0h22.352v22.352H0z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_7100",
  "data-name": "Group 7100"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_4225",
  "data-name": "Path 4225",
  d: "M14.814 6.6l-3.638 3.637L7.539 6.6 5.771 8.367 9.408 12l-3.637 3.641 1.768 1.768 3.637-3.638 3.638 3.638 1.768-1.768L12.943 12l3.638-3.637z",
  transform: "translate(0 -.828)",
  fill: "#ec1b3b"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_7013",
  "data-name": "Group 7013"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_7012",
  "data-name": "Group 7012",
  clipPath: "url(#clip-path)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_4226",
  "data-name": "Path 4226",
  d: "M11.176 0a11.176 11.176 0 1011.176 11.176A11.189 11.189 0 0011.176 0m0 20.051a8.875 8.875 0 118.875-8.875 8.885 8.885 0 01-8.875 8.875",
  fill: "#ec1b3b"
}))))));